var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('van-radio-group',_vm._g(_vm._b({attrs:{"direction":"horizontal"}},'van-radio-group',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.options),function(item){return _c('van-radio',{key:item.value,attrs:{"name":item.value}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }